export const setPdfDownloadStatus = (value) => {
	return { type: "SET_PDF_DOWNLOAD_STATUS", payload: value };
};